import { API_BASE_URL } from '../config.js';
import { useFetch } from './useFetchAuth.js';
export default function useStaticData() {
  const {
    data: clients,
    isPending: isLoadingClients,
    error: errorClients
  } = useFetch(
    'clients',
    `${API_BASE_URL}/api/clients/`
  );
  const {
    data: shopSigns,
    isPending: isLoadingShopSigns,
    error: errorShopSigns
  } = useFetch(
    'shop_signs',
    `${API_BASE_URL}/api/shop_signs/`
  );
  // Combine loading and error states
  const loading = isLoadingClients || isLoadingShopSigns;
  
  // Return the first error message encountered, if any
  const error = errorClients?.message || errorShopSigns?.message || null;

  return { clients, shopSigns, loading, error };
}